import React, { useState } from "react";
import css from "./Header.module.css";
import logo from "../../assets/logo.png";
import { CgShoppingBag } from "react-icons/cg";
import { IoReorderThreeSharp } from "react-icons/io5";

const Header = () => {
  const [showMenu, setshowMenu] = useState(true);

  const toggleMenu = () => {
    setshowMenu((showMenu) => !showMenu);
  };
  return (
    <div className={css.container}>
      <div className={css.logo}>
        <img src={logo} alt="Logo" />
        <span>Glow Cosmetics</span>
      </div>
      <div className={css.right}>
        <div className={css.bars} onClick={toggleMenu}>
          <IoReorderThreeSharp />
        </div>

        <div
          className={css.menu}
          style={{ display: showMenu ? "inherit" : "none" }}
        >
          <li>Collection</li>
          <li>Brands</li>
          <li>New</li>
          <li>Sales</li>
          <li>ENG</li>
        </div>

        <input type="text" className={css.search} placeholder="search" />
        <CgShoppingBag className={css.cart} />
      </div>
    </div>
  );
};

export default Header;
